import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Weird feeds",
  "description": "",
  "published": "2011-10-20T00:00:00.000Z",
  "redirect_from": ["/blog/weird-feeds/swizec/2676"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Hello anyone subscribed via a feed reader. This isn't a real post, just a quick note to all of you who have been complaining about repeated posts.`}</p>
    <p>{`Over the past week or so I moved my feed over to feedburner. While doing that things went wrong and I spammed all of you with a few tens of repeated posts.`}</p>
    <p>{`Oops.`}</p>
    <p>{`Then two days ago I finally figured out how to convince feedburner to use a full feed instead of excerpts. This lead to more spamming and I'm told some people are now receiving each post twice.`}</p>
    <p>{`If you're one of the people having issues, I suggest you replace your subscriptions with this link:`}</p>
    <p><a parentName="p" {...{
        "href": "http://feeds.feedburner.com/AGeekWithAHat2"
      }}>{`http://feeds.feedburner.com/AGeekWithAHat2`}</a></p>
    <p>{`That is the direct real feed now so hopefully there won't be any problems :)`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=d3d3bab9-b81c-4c55-9315-290b360817ad",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      